export const API_END_POINT = {
  PopularMovies: 'popular_moives/',
  PopularCharacter: 'popular_character/',
  Delete: 'user/v1/auth/user/deactivate',
  SuggestedRail: 'bc_suggested_for/',
  SuggestedFor: 'suggested_for/',
  menuItems: 'bottom_menu/',
  creditTransaction: 'v1/wallet/credits/transactions',
  creditBalance: 'v1/wallet/credits/balance',
  coinBalance: 'v2/rewards/get/balance',
  coinConvert: 'v1/wallet/coins/convert',
  getPaymentPlans: '/v1/payments/plan/get_plans_detailed',
  getActivePlans: '/v1/payments/subscription/active',
  cancleSubscription: '/v1/payments/subscription/cancel',
  pendingSubscription: '/v1/payments/subscription/create-pending',
  productDetails: '/v1/payments/plan/get_product_details',
  planEntitlement: '/v1/payments/plan/get_entitlements',
  allVendorPayment: '/v1/payments/vendor/fetch_all',
  vendorPaymentDetails: '/v1/payments/vendor/fetch',
  createTransaction: '/v1/payments/transaction/create',
  createSubscription: '/v1/payments/subscription/create',
  getTransactionStatus: '/v1/payments/transaction/check-status',
  getSubscriptionStatus: '/v1/payments/subscription/status',
  getSubscriptionTransactions: 'v1/payments/subscription/transactions',
  getRewardsTransactions: '/v2/rewards/get/transactions',
  priceBreakup: '/v1/payments/pricing/fetch_price_breakup',
  firebaseToken: '/v1/auth/devices',
  syncPushToken: 'user/v1/device/sync-token',
  notification: '/v1/comm/push/notificationByUUID/',
  deleteNotification: '/v1/comm/push/notifications/delete',
  aitoolsNotificationStream: 'aitools/notifications/stream',
  aitoolsDownload: (generationId) => `aitools/jobs/${generationId}/download`,
  logout: 'user/v1/auth/user/logout',
  updatePwd: '/v1/auth/users/set_password',
  changePassword: 'user/v1/auth/user/change_password',
  discover: 'discover/v2',
  sidebarMenu: '/v1/superapp_side_menu',
  rewardTabs: 'coupon/data/',
  getRewardCategory: 'coupon/v2/category',
  redeemCoupon: 'coupon/redeem',
  getCouponInfo: 'coupon/v2/get-coupon-info',
  subscriptionButtonState: '/v1/payments/subscription/button-state',
  voiceHints: '/v1/voices/hints/',
  presetVoices: '/v1/voices/presets/',
  userVoices: '/v1/voices/user/',
  uploadVoice: 'v1/voices/',
  generateAudio: 'voiceclone/generate_audio/',
  voiceCloneStatus: 'voiceclone/status/',
  speakerDetection: 'test_speaker_detection',
  speakerDetectionStatus: 'status/test_speaker_detection/',
  share: '/content_share',
  templateShare:'/creator-economy/v1/templates/template_share',
  generateTalkingAvatar: 'talking-avatar/videos/process',
  reGenerateTalkingAvatar: 'talking-avatar/videos/',
  reGenerate: '/regenerate',
  talkingAvatarStatus: 'talking-avatar/videos/',
  status: '/status',
  talkingAvatarHints: '/v1/talking_avatar/action_hint/',
  actionGeneration: '/action-generation',
  getActionGenerationStatus: '/action-generation/status/',
  actionGenerationActionsList: 'v1/action_generation/action_key/',
  earnMoreCoin: 'earn_more_coin/',
  imageToVideoGenerate: '/image-to-video',
  imageToVideoStatus: '/i2v/status/',
  imageToVideoHints: '/v1/image-to-video/hints/',
  imageToVideoDurations: '/v1/image-to-video/durations/',
  initiateStripePayment: '/v1/payments/transaction/initiate-stripe-payment/',
  aiToolsHistory: '/v1/aitools-history',
  presignedUpload: '/aiproxy/v1/create/tools/upload/v1/presigned',
  checkPaymentStatus: '/v1/payments/transaction/check-status',
  regenerateVoiceClone: 'voiceclone/regenerate_audio',
  feed: 'feed',
  streamJobChild:"stream-job-child",
  motionTemplates: '/v1/motion/',
  motionControlGenerate: '/motion-control/generate',
  motionControlHints: '/v1/text-to-video/hints/',
  verifyPassword: 'user/v1/auth/user_profile/verify_password',
  howItWorks: '/v1/how_it_works',
  userJourneyAnalytics: '/analytics/v1/event/user_journey',
  subscriptionAnalytics: '/analytics/v1/event/subscription',
  analyticsEvents:'/analytics/v1/event',
  userRegisterAnalytics: '/analytics/v1/event/user_register',
  userSearchAnalytics: '/analytics/v1/event/search',
  trackAnalytics:'/analytics/v1/track',
  playedAnalytics:'/analytics/v1/event/contentplayed',
  playerMatrics:'/analytics/v1/event/playerMetrics'
}

export const QUERY_KEY = {
  GetPopularMovies: 'GET_POPULAR_MOVIES',
  GetPopularCharacters: 'GET_POPULAR_CHARACTERS',
  GetSuggestedRail: 'GET_SUGGESTED_RAIL',
  DeleteAccount: 'DELETE_ACCOUNT',
  GetMenuItems: 'GetMenuItems',
  GetCoinTransaction: 'GetCoinTransaction',
  GetCreditTransaction: 'GetCreditTransaction',
  GetCreditBalance: 'GetCreditBalance',
  GetCoinBalance: 'GetCoinBalance',
  GET_PLAN: 'GET_PLAN_DETAILS',
  GET_ACTIVE_PLAN: 'GET_ACTIVE_PLAN',
  CANCLE_SUBSCRIPTION: 'cancleSubscription',
  PENDING_SUBSCRIPTION: 'pendingSubscription',
  GET_PRODUCET_DETAILS: 'productDetails',
  GET_ENTITLEMENT: 'planEntitlement',
  GET_PAYMENT_VENDOR: 'allVendorPayment',
  GET_VENDOR_PAYMENT_DETAILS: 'vendorPaymentDetails',
  CREATE_TRANSACTION: 'createTransaction',
  CREATE_SUBSCRIPTION: 'createSubscription',
  GET_TRANSACTION_STATUS: 'getTransactionStatus',
  GET_SUBSCRIPTION_STATUS: 'getSubscriptionStatus',
  GET_SUBSCRIPTION_TRANSACTIONS: 'getSubscriptionTransactions',
  GET_PRICE_BREAKUP: 'priceBreakup',
  GET_FIREBASE_TOKEN: 'getFirebaseToken',
  SYNC_PUSH_TOKEN: 'syncPushToken',
  GET_NOTIFICATIONS: 'getNotification',
  LOGOUT: 'logoutAccount',
  GET_DISCOVER_DATA: 'getDiscoverData',
  GET_SIDEBAR_MENU: 'getSideBarMenu',
  GET_REWARD_TABS: 'getRewardTabs',
  GET_REWARD_CATEGORY: 'getRewardCategory',
  GET_COUPON_INFO: 'getCouponInfo',
  GET_REEDEM_REWARDS: 'getRedeemRewards',
  GET_SHARE: 'getShare',
  GET_ACTION_GENERATION: 'getActionGeneration',
  GET_ACTION_GENERATION_LIST: 'getActionGenerationList',
  GET_ACTION_GENERATION_STATUS: 'getActionGenerationStatus',
  GET_MORE_COIN: 'earnMoreCoin',
  GENERATE_IMAGE_TO_VIDEO: 'generateImageToVideo',
  GET_IMAGE_TO_VIDEO_STATUS: 'getImageToVideoStatus',
  IMAGE_TO_VIDEO_HINTS: 'IMAGE_TO_VIDEO_HINTS',
  IMAGE_TO_VIDEO_DURATIONS: 'IMAGE_TO_VIDEO_DURATIONS',
  GET_USER_LIKES: 'USER_LIKES',
  INITITATE_PAYMENT: 'initiatePayment',
  AI_TOOLS_HISTORY: 'GET_AI_TOOLS_HISTORY',
  CHECK_PAYMENT_STATUS: 'checkPaymentStatus',
  GET_SUPER_APP_SOCIAL_HOME: 'GET_SUPER_APP_SOCIAL_HOME',
  GET_SUPER_APP_HOME_PAGE_ID: 'GET_SUPER_APP_HOME_PAGE_ID',
  GET_SUPER_APP_HOME_SECTION_ITEM: 'GET_SUPER_APP_HOME_SECTION_ITEM',
  GET_CREATOR_HOME: 'GET_CREATOR_HOME',
  GET_DASHBOARD_SOCIAL_HOME: 'GET_DASHBOARD_SOCIAL_HOME',
  GET_MOTION_TEMPLATES: 'GET_MOTION_TEMPLATES',
  GENERATE_MOTION_CONTROL: 'GENERATE_MOTION_CONTROL',
  GET_MOTION_CONTROL_STATUS: 'GET_MOTION_CONTROL_STATUS',
  GET_MOTION_CONTROL_HINTS: 'GET_MOTION_CONTROL_HINTS',
  GET_CONTENT_DETAILS_BY_ID:"GET_CONTENT_DETAILS_BY_ID",
  GET_CREATOR_ECONOMY_LIST:'GET_CREATOR_ECONOMY_LIST',
  GET_USER_DASHBOARD:"GET_USER_DASHBOARD",
  GET_USER_DASHBOARD_DETAIL: 'GET_USER_DASHBOARD_DETAIL',
  GET_HOW_IT_WORKS: 'GET_HOW_IT_WORKS',
  GET_COUNTINUE_EDITING: 'GET_COUNTINUE_EDITING',
  USER_JOURNEY_ANALYTICS: 'USER_JOURNEY_ANALYTICS',
  BANNER_IMAGE_LIST:'BANNER_IMAGE_LIST'
}

export const API_METHOD = {
  Get: 'get',
  Post: 'post',
  Delete: 'delete',
  Put: 'put',
  Patch: 'patch'
}
